import PropTypes from "prop-types"
import { formatLongDate } from "helpers/formatters/dates"
import { CHART_ITEM } from "helpers/shapes"
import SelectedTooltipItem from "components/charts/selected-tooltip-item"

function SecurityProfileTooltip({ id, formatter, datum, cumulativeTrend, alphaTrend, factorTrend, tradingPnl }) {
  if (datum) {
    return <div>
      <div className="header">{formatLongDate(datum.date)}</div>
      <SelectedTooltipItem id="total" currentId={id} data={cumulativeTrend} index={datum.index} formatter={formatter} label="Total" />
      <SelectedTooltipItem id="alpha" currentId={id} data={alphaTrend} index={datum.index} formatter={formatter} label="Alpha" />
      <SelectedTooltipItem id="factor" currentId={id} data={factorTrend} index={datum.index} formatter={formatter} label="Factor" />
      {tradingPnl && tradingPnl.length > 0
        && <SelectedTooltipItem id="trading" currentId={id} data={tradingPnl} index={datum.index} formatter={formatter} label="Trading" />}
    </div>
  } else {
    return null
  }
}

SecurityProfileTooltip.propTypes = {
  id: PropTypes.string.isRequired,
  datum: CHART_ITEM,
  cumulativeTrend: PropTypes.arrayOf(CHART_ITEM).isRequired,
  alphaTrend: PropTypes.arrayOf(CHART_ITEM).isRequired,
  factorTrend: PropTypes.arrayOf(CHART_ITEM).isRequired,
  tradingPnl: PropTypes.arrayOf(CHART_ITEM),
  formatter: PropTypes.func.isRequired,
}

export default SecurityProfileTooltip
